import React from "react";
import '../../styles/table-main/main.css';

const Main = () => {
    return (
        <div id="tableMain">
            <div className="table-inner-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Enquiry Numbers</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Department</th>
                                                <th>Department Designation</th>
                                                <th>Name of Head</th>
                                                <th>Phone Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>VICE CHANCELLOR OFFICE</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>0121-2760554</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>REGISTRAR OFFICE</td>
                                            <td>PA TO REGISTRAR</td>
                                            <td>-</td>
                                            <td>0121-2604570</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>FINANCE OFFICE</td>
                                            <td>OFFICE INCHARGE</td>
                                            <td>SH. AASHISH KUMAR</td>
                                            <td>0121-2761439</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>FINANCE OFFICE</td>
                                            <td>PA TO FINANCE OFFICER</td>
                                            <td>SH. ARUN VASHISTHA</td>
                                            <td>0121-2761439</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>EXAM CONTROLLER OFFICE</td>
                                            <td>PA TO EXAM CONTROLLER</td>
                                            <td>SH. R.S VERMA</td>
                                            <td>9412578913</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>EXAM CONTROLLER OFFICE</td>
                                            <td>SR. ASSTT. (EXAM CONTROLLER OFFICE)</td>
                                            <td>SH. DEVENDRA KUMAR</td>
                                            <td>0121-2759525</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>B.ED CELL</td>
                                            <td>INCHARGE</td>
                                            <td>SH. SARVOTTAM SHARMA</td>
                                            <td>9045358908</td>
                                        </tr>
                                        <tr>
                                            <td>8</td>
                                            <td>B.ED. CELL</td>
                                            <td>SR. ASSTT.</td>
                                            <td>SH. KAPIL SHARMA</td>
                                            <td>9719311333</td>
                                        </tr>
                                        <tr>
                                            <td>9</td>
                                            <td>INCHARGE DEGREE</td>
                                            <td>Pradhan Sahayak</td>
                                            <td>SH. BHANU PRATAP</td>
                                            <td>7547880888</td>
                                        </tr>
                                        <tr>
                                            <td>10</td>
                                            <td>EXAMINATION DEPARTMENT</td>
                                            <td>INCHARGE</td>
                                            <td>SH. SUSHIL KUMAR</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td>11</td>
                                            <td>FIRST APEAL AUTHORITY OFFICE</td>
                                            <td>FIRST APEAL OFFICE</td>
                                            <td>SH. DEEPAK RATHOR</td>
                                            <td>0121-2973207, 9410455164</td>
                                        </tr>
                                        <tr>
                                            <td>12</td>
                                            <td>RTI DEPARTMENT</td>
                                            <td>INCHARGE</td>
                                            <td>SH. LAXMI CHAND</td>
                                            <td>9719446027</td>
                                        </tr>
                                        <tr>
                                            <td>13</td>
                                            <td>CONFIDENTIAL DEPARTMENT</td>
                                            <td>SR. ASSTT. (CONFIDENTIAL DEPARTMENT)</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr>
                                        <tr>
                                            <td>14</td>
                                            <td>PRACTICAL SECTION (CONF.)</td>
                                            <td>INCHARGE, PRACTICAL SECTION</td>
                                            <td>SH. SATPAL</td>
                                            <td>9410888690</td>
                                        </tr>
                                        <tr>
                                            <td>15</td>
                                            <td>PROFESSIONAL CELL ENQUIRY</td>
                                            <td>INCHARGE PROFESSIONAL CELL</td>
                                            <td>SH. RAJKUMAR</td>
                                            <td>9997013941</td>
                                        </tr>
                                        <tr>
                                            <td>16</td>
                                            <td>INCHARGE, COMMITTEE CELL</td>
                                            <td>OFFICE INCHARGE</td>
                                            <td>AVIRAL KUMAR SHARMA</td>
                                            <td>9412703504</td>
                                        </tr>
                                        <tr>
                                            <td>17</td>
                                            <td>INCHARGE, BBA (PROF. CELL)</td>
                                            <td>JR. ASSTT. (PROF. CELL)</td>
                                            <td>SH. GYAN SINGH RAWAT</td>
                                            <td>9456262767</td>
                                        </tr>
                                        <tr>
                                            <td>18</td>
                                            <td>INCHARGE, BCA (PROF. CELL)</td>
                                            <td>JR. ASSTT. (PROF. CELL)</td>
                                            <td>SH. VIKAS</td>
                                            <td>9897535807</td>
                                        </tr>
                                        <tr>
                                            <td>19</td>
                                            <td>MEDICAL FACULTY (PROF. CELL)</td>
                                            <td>SKILLED (PROF. CELL)</td>
                                            <td>SH. MAHESH BHATI</td>
                                            <td>7060756559</td>
                                        </tr>
                                        <tr>
                                            <td>20</td>
                                            <td>PH.D. ENQUIRY</td>
                                            <td>SR. ASSTT.</td>
                                            <td>SH. SATENDRA BHANDARI</td>
                                            <td>9105260142</td>
                                        </tr>
                                        <tr>
                                            <td>21</td>
                                            <td>AFFILIATION SECTION</td>
                                            <td>A.R. AFFILIATION</td>
                                            <td>SH. VINAY KUMAR</td>
                                            <td>9415174989</td>
                                        </tr>
                                        <tr>
                                            <td>22</td>
                                            <td>GENERAL SECTION</td>
                                            <td>SR. ASSTT</td>
                                            <td>SH. SALEK CHAND</td>
                                            <td>8077805085</td>
                                        </tr>
                                        <tr>
                                            <td>23</td>
                                            <td>GENERAL SECTION (STORE)</td>
                                            <td>INCHARGE</td>
                                            <td>SH. HARSH GUPTA</td>
                                            <td>7906005435</td>
                                        </tr>
                                        <tr>
                                            <td>24</td>
                                            <td>SIR CHHOTU RAM INSTITUTE OF ENGINEERING & TECHNOLOGY</td>
                                            <td>NETWORK ADMINISTRATOR</td>
                                            <td>SH. SANDEEP AGARWAL</td>
                                            <td>9837337799</td>
                                        </tr>
                                        <tr>
                                            <td>25</td>
                                            <td>DISPENSARY</td>
                                            <td>UNIVERSITY DOCTOR</td>
                                            <td>DR. PRAMOD KR. BANSAL</td>
                                            <td>9837134338</td>
                                        </tr>
                                        <tr>
                                            <td>26</td>
                                            <td>ANSWER BOOK SECTION</td>
                                            <td>INCHARGE</td>
                                            <td>SH. HARISH KUMAR</td>
                                            <td>0121-2600506, 8958702786</td>
                                        </tr>
                                        <tr>
                                            <td>27</td>
                                            <td>ANSWER BOOK SECTION</td>
                                            <td>SKILLED</td>
                                            <td>SH. RAJKUMAR</td>
                                            <td>7417557610</td>
                                        </tr>
                                        <tr>
                                            <td>28</td>
                                            <td>STUDENT HELP CENTRE</td>
                                            <td>INCHARGE</td>
                                            <td>SH. SANJAY TOMAR</td>
                                            <td>9411667784</td>
                                        </tr>
                                        <tr>
                                            <td>29</td>
                                            <td>RESULT Cell</td>
                                            <td>SR. ASSTT</td>
                                            <td>SH. RAJEEVPAL</td>
                                            <td>7599557520</td>
                                        </tr>
                                            {/* <tr>
                                                <td>1</td>
                                                <td>B.ED CELL</td>
                                                <td>INCHARGE</td>
                                                <td>SH. SARVOTTAM SHARMA</td>
                                                <td>9412892007</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>INCHARGE DEGREE</td>
                                                <td>SR. ASSTT</td>
                                                <td>
                                                    <p>SH. HARSH VARDHAN SHARMA</p>
                                                </td>
                                                <td>
                                                    <p>9456087122</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>EXAMINATION DEPARTMENT</td>
                                                <td>INCHARGE</td>
                                                <td>--</td>
                                                <td>--</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>REGISTRAR OFFICE</td>
                                                <td>----</td>
                                                <td>&nbsp;</td>
                                                <td>0121-2604570, 0121-2764777</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>FINANCE OFFICE</td>
                                                <td>OFFICE INCHARGE</td>
                                                <td>SH. AASHISH KUMAR</td>
                                                <td>0121-2761439</td>
                                            </tr>
                                            <tr>
                                                <td>6</td>
                                                <td>FINANCE OFFICE</td>
                                                <td>PA TO FINANCE OFFICER</td>
                                                <td>SH. ARUN VASHISTHA</td>
                                                <td>0121-2761439</td>
                                            </tr>
                                            <tr>
                                                <td>7</td>
                                                <td>FIRST APEAL AUTHORITY OFFICE</td>
                                                <td>PA TO FIRST APEAL OFFICE</td>
                                                <td>SH. RAJIV MALHOTRA</td>
                                                <td>0121-2973207</td>
                                            </tr>
                                            <tr>
                                                <td>8</td>
                                                <td>FIRST APEAL AUTHORITY OFFICE</td>
                                                <td>FIRST APEAL OFFICE</td>
                                                <td>SH. VINAY KUMAR PAL</td>
                                                <td>0121-2973207</td>
                                            </tr>
                                            <tr>
                                                <td>9</td>
                                                <td>EXAM CONTROLLER OFFICE</td>
                                                <td>PA TO EXAM CONTROLLER</td>
                                                <td>SH. R.S VERMA</td>
                                                <td>8171954852</td>
                                            </tr>
                                            <tr>
                                                <td>10</td>
                                                <td>EXAM CONTROLLER OFFICE</td>
                                                <td>SR. ASSTT. (EXAM CONTROLLER OFFICE)</td>
                                                <td>SH. DEVENDRA KUMAR</td>
                                                <td>0121-2759525</td>
                                            </tr>
                                            <tr>
                                                <td>11</td>
                                                <td>RIGHT TO INFORMATION OFFICE</td>
                                                <td>INCHARGE GENERAL</td>
                                                <td>SH. SUSHIL KUMAR</td>
                                                <td>8279906600</td>
                                            </tr>
                                            <tr>
                                                <td>12</td>
                                                <td>RIGHT TO INFORMATION OFFICE</td>
                                                <td>SKILLED</td>
                                                <td>SH. DEEPAK RATHOR</td>
                                                <td>9410455164</td>
                                            </tr>
                                            <tr>
                                                <td>13</td>
                                                <td>MARKSHEET &amp; RESULT ENQUIRY</td>
                                                <td>ASST. REGISTRAR (CONF.)</td>
                                                <td>-</td>
                                                <td>-</td>
                                            </tr>
                                            <tr>
                                                <td>14</td>
                                                <td>PRACTICAL SECTION (CONF.)</td>
                                                <td>INCHARGE, PRACTICAL SECTION</td>
                                                <td>SH. PARVEEN RANA</td>
                                                <td>9897081972</td>
                                            </tr>
                                            <tr>
                                                <td>15</td>
                                                <td>PROFESSIONAL CELL ENQUIRY</td>
                                                <td>INCHARGE PROFESSIONAL CELL</td>
                                                <td>SH. RAJKUMAR</td>
                                                <td>9997013941</td>
                                            </tr>
                                            <tr>
                                                <td>16</td>
                                                <td>INCHARGE, COMMITTEE CELL</td>
                                                <td>OFFICE SUPTD.</td>
                                                <td>Aviral Kumar Sharma</td>
                                                <td>8445773506</td>
                                            </tr>
                                            <tr>
                                                <td>17</td>
                                                <td>COMMITTEE CELL</td>
                                                <td>ASSTT. OFFICE SUPTD.</td>
                                                <td>SH. ACHRAJ MANGLIK</td>
                                                <td>9837039495</td>
                                            </tr>
                                            <tr>
                                                <td>18</td>
                                                <td>INCHARGE, BBA (PROF. CELL)</td>
                                                <td>JR. ASSTT. (PROF. CELL)</td>
                                                <td>SH. AJAY KUMAR</td>
                                                <td>7520232708</td>
                                            </tr>
                                            <tr>
                                                <td>19</td>
                                                <td>INCHARGE, BCA (PROF. CELL)</td>
                                                <td>JR. ASSTT. (PROF. CELL)</td>
                                                <td>SH. VIKAS</td>
                                                <td>9897535807</td>
                                            </tr>
                                            <tr>
                                                <td>20</td>
                                                <td>MEDICAL FACULTY (PROF. CELL)</td>
                                                <td>SKILLED (PROF. CELL)</td>
                                                <td>SH. YOGESH YADAV</td>
                                                <td>8923807070</td>
                                            </tr>
                                            <tr>
                                                <td>21</td>
                                                <td>PH.D. ENQUIRY</td>
                                                <td>SR. ASSTT.</td>
                                                <td>SH. YASHPAL</td>
                                                <td>9558333264</td>
                                            </tr>
                                            <tr>
                                                <td>22</td>
                                                <td>B.ED. OFFICE</td>
                                                <td>SKILLED</td>
                                                <td>SH. PUNEET KUMAR</td>
                                                <td>9536322233</td>
                                            </tr>
                                            <tr>
                                                <td>23</td>
                                                <td>AFFILIATION SECTION</td>
                                                <td>OFFICE SUPTD. (AFF.)</td>
                                                <td>SH. LALIT SHARMA</td>
                                                <td>9997444604</td>
                                            </tr>
                                            <tr>
                                                <td>24</td>
                                                <td>GENERAL SECTION</td>
                                                <td>JR. ASSTT</td>
                                                <td>SH. SHANKER SINGH</td>
                                                <td>9634666649</td>
                                            </tr>
                                            <tr>
                                                <td>25</td>
                                                <td>GENERAL SECTION (STORE)</td>
                                                <td>INCHARGE</td>
                                                <td>SH. HARSH GUPTA</td>
                                                <td>7906005435</td>
                                            </tr>
                                            <tr>
                                                <td>26</td>
                                                <td>GENERAL SECTION (STORE)</td>
                                                <td>JR. ASSTT.&nbsp;&nbsp;</td>
                                                <td>SH. KARAN THAPA</td>
                                                <td>7088825763</td>
                                            </tr>
                                            <tr>
                                                <td>27</td>
                                                <td>
                                                    SIR CHHOTU RAM INSTITUTE OF ENGINEERING &amp;
                                                    TECHNOLOGY
                                                </td>
                                                <td>NETWORK ADMINISTRATOR</td>
                                                <td>SH. SANDEEP AGARWAL</td>
                                                <td>9368624467</td>
                                            </tr>
                                            <tr>
                                                <td>28</td>
                                                <td>DISPENSARY</td>
                                                <td>UNIVERSITY DOCTOR</td>
                                                <td>DR. PRAMOD KR. BANSAL</td>
                                                <td>9837134338</td>
                                            </tr>
                                            <tr>
                                                <td>29</td>
                                                <td>ANSWER BOOK SECTION</td>
                                                <td>INCHARGE</td>
                                                <td>SH. PREM CHAND</td>
                                                <td>0121-2600506</td>
                                            </tr>
                                            <tr>
                                                <td>30</td>
                                                <td>ANSWER BOOK SECTION</td>
                                                <td>SKILLED</td>
                                                <td>SH. RAJKUMAR</td>
                                                <td>7417557610</td>
                                            </tr>
                                            <tr>
                                                <td>31</td>
                                                <td>STUDENT HELP CENTRE</td>
                                                <td>INCHARGE</td>
                                                <td>SH. SANJAY TOMAR</td>
                                                <td>9411667784</td>
                                            </tr>
                                            <tr>
                                                <td>32</td>
                                                <td>STUDENT HELP CENTRE</td>
                                                <td>SKILLED</td>
                                                <td>SMT. AMITA BHARDWAJ</td>
                                                <td>9411822076</td>
                                            </tr>
                                            <tr>
                                                <td>33</td>
                                                <td>RESULT CELL</td>
                                                <td>SR. ASSTT</td>
                                                <td>SH. RAJEEVPAL</td>
                                                <td>7599557520</td>
                                            </tr>
                                            <tr>
                                                <td>34</td>
                                                <td>Examination Form Submission</td>
                                                <td>---</td>
                                                <td>Shri Vipin Tyagi, Shri Gaurav</td>
                                                <td>09897219109, 09259362743</td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
